// @flow

/**
 * Header's top menu item
 */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { AnalyticsContext, trackEvent } from 'latitude-analytics';
import MediaQuery from 'react-responsive';
import SvgInline from '@latitude/svg-inline';
import Section from '@latitude/section';
// import { Link } from '@latitude/link';
import { ANALYTICS } from '@latitude/core/utils/constants';
import {
  DESKTOP_CUTOFF_POINT,
  MOBILE_CUTOFF_POINT,
} from './BaseHeader.constant';
import './_top-menu-item.scss';
import { Link } from '../Link/Link';

type Props = {
  className?: string,
  id: string,
  label: string,
  active: boolean,
  children: React.Node,
  onClick: (string) => void,
  trackId?: string,
  href?: string,
  target?: string,
  // eslint-disable-next-line flowtype/no-weak-types
  items?: Array<Object>
};

const TopMenuItem = (props: Props) => {
  const { id, label, active, onClick, trackId, href, target, items } = props;
  let { className } = props;
  const linkProps = {};
  const [analytics] = useContext(AnalyticsContext);

  if (href) {
    className = classnames('top-menu-item--link', className);
    linkProps.href = href;
    linkProps.target = target;
    /**
     * TODO: Awaiting confirmation from Matt E and tagging team on the below
     * - Need to confirm if domain will be one of ours
     * - Need to append gemid value for the link
     */
    linkProps.onClick = (event: SyntheticEvent<HTMLAnchorElement>) => {
      trackEvent(analytics, {
        category: 'text-link',
        action: 'internal-link',
        label: event.currentTarget.innerText,
        location: ANALYTICS.LOCATION.HEADER,
      });
    };
  } else {
    linkProps.onClick = () => onClick(props.id);
  }

  return (
    <div
      key={id}
      className={classnames('top-menu-item', className, {
        'is-active': active,
      })}
    >
      {items && items.length && (
        <>
          <a
            className="top-menu-item__button link--no-style trackcustomanalytics"
            {...linkProps}
            data-trackid={trackId}
          >
            {label && <p className="top-menu-item__label">{label}</p>}
            <SvgInline
              className="top-menu-item__chevron"
              name="chevron-right"
            />
          </a>
          <div className="top-menu-item__content">
            {/* mobile */}
            <MediaQuery maxWidth={MOBILE_CUTOFF_POINT}>
              {props.children}
            </MediaQuery>

            {/* Desktop */}
            <MediaQuery minWidth={DESKTOP_CUTOFF_POINT}>
              <Section>{props.children}</Section>
            </MediaQuery>
          </div>
        </>
      )}

      {/* If the menu item has no child items using Link component */}
      {!items && (
        <Link
          className="top-menu-item__button link--no-style trackcustomanalytics"
          {...linkProps}
          data-trackid={trackId}
          trackEventData={{
            label,
          }}
        >
          {label && <p className="top-menu-item__label">{label}</p>}
          <SvgInline className="top-menu-item__chevron" name="chevron-right" />
        </Link>
      )}
    </div>
  );
};

export default TopMenuItem;
